import { createService, z } from '@bonanza-social/toolkit/api';
import {
  ClaimAllStatusRewardsResponseSchema,
  StatusResponseSchema,
} from './StatusService.schemas';

export default createService(
  {
    getStatus: {
      method: 'GET',
      url: '/loyalty/statuses',
      responseSchema: StatusResponseSchema,
      headers: {
        'x-feature-loyalty-revamp': true,
      },
    },
    acknowledgeStatus: {
      method: 'POST',
      url: '/loyalty/statuses/acknowledge',
      responseSchema: z.object({}).optional(),
    },
    claimAllStatusRewards: {
      method: 'POST',
      url: '/rewards/redemptions',
      responseSchema: ClaimAllStatusRewardsResponseSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
